export const CONTEXT_ROUTE = '/:appName?'
export const REGISTRATION_ROUTE = '/registration'
export const LOGIN_APP_ROUTE = '/:appName?/login/'
export const LOGIN_APP_ROUTE_WITH_LANG = '/:appName?/login/:locale'
export const LOGIN_ROUTE = '/login'
export const LOGOUT_ROUTE = '/logout'
export const LOGOUT_SUCCESS = '/message/logoutsuccess'
export const FAILED_POLICY = '/error/failedpolicy'
export const SECURITY_WARNING = '/error/securitywarning'
export const APP_MAINTENANCE = '/message/appmaintenance'
export const APP_INACTIVE = '/error/appinactive'
export const FORGOTPWD_ROUTE = '/forgotpwd'
export const SESSION_TIMEOUT = '/session-timeout'
export const PASSWORD_CHANGED = '/message/password-changed'
export const NO_ACCESS = '/error/noaccess'
export const SSO_ERROR = '/error/ssoerror'
export const ANALYTICS_REGISTER = '/analytics/register/'
export const ANALYTICS_REGISTER_WITH_LANG = '/analytics/register/:locale'
export const DEFAULT_REGISTER = '/register'
export const DEFAULT_REGISTER_WITH_LANG = '/register/:locale'
export const HEDGEX_LANDING = '/hedgex'
export const HEDGEX_LANDING_WITH_LANG = '/hedgex/:locale'
export const AAG_LANDING = '/aa'
export const AAG_LANDING_WITH_LANG = '/aa/:locale'
export const MAGIC_LINK = '/magic-link'
